(function() {
    'use strict';

    angular
        .module('adjustBenApp')
        .controller('AdjustBenDialogController', AdjustBenDialogController);

    AdjustBenDialogController.$inject = ['$scope', '$uibModalInstance', 'items','NgTableParams'];

    function AdjustBenDialogController ($scope, $uibModalInstance, items,NgTableParams) {
    	var adjustBenDial = this;
    	var data = items;
    	adjustBenDial.items = items;
    	adjustBenDial.tableParams = new NgTableParams({
  	      page: 1, // show first page
  	      count: 3 // count per page
  	    }, {
  	      filterDelay: 0,
  	      dataset: data
  	    });
    	adjustBenDial.ok= ok;
    	adjustBenDial.cancel= cancel;
    	adjustBenDial.selected = {
    	    item: adjustBenDial.items[0]
    	  };

    	  function ok() {
    	    $uibModalInstance.close(adjustBenDial.selected.item);
    	  };

    	  function cancel() {
    	    $uibModalInstance.dismiss('cancel');
    	  };
    }
})();
